<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    region: LayoutRegion;
    classes?: string;
    binds?: LayoutRegionBinds;
  }>(),
  {
    classes: "empty:hidden",
    binds: undefined,
  },
);

const { setLayoutRegion } = useLayoutRegion(
  () => props.region,
  () => props.binds,
);
</script>

<template>
  <client-only>
    <div :ref="setLayoutRegion" :class="props.classes" />
  </client-only>
</template>
